import React, { useMemo } from 'react'
import Label from 'LuxKit/Label'

interface Props {
  variant?: App.MerchandiseOfferVariant
  variants?: Array<App.MerchandiseOfferVariant>
}

function MerchandiseFreeShippingLabel({ variant, variants }: Props) {
  const hasFreeShipping = useMemo(() => {
    const variantsToCheck = variant ? [variant] : variants
    return variantsToCheck?.every(v =>
      !v.shippingProfile || v.shippingProfile.rates.some(rate => rate.amount === 0),
    )
  }, [variant, variants])

  if (!hasFreeShipping) {
    return null
  }

  return <Label kind="tertiary" variant="highlight">
    Free shipping
  </Label>
}

export default MerchandiseFreeShippingLabel
